import { FieldProps } from '~components/form-fields/props';

import BudgetSections from '../../components/budgets/BudgetSections';

const editBudgetFields: FieldProps = {
  id: {
    type: 'hidden',
  },
  sections: {
    type: 'custom',
    component: BudgetSections,
    dependencies: [
      'id',
      'supplements',
      'sections',
      'price_plan_revision_id',
      'price_plan_deleted',
      'client_id',
      'client_sah_budget_id',
      'package_fixed_id',
      'start_date',
      'end_date',
      'total_amount',
      'available_amount',
      'grand_total',
      'total_includes_case_management',
      'status_id',
      'ignore_sah_filters',
    ],
    colSize: 12,
    order: 500,
  },
};

export default editBudgetFields;
